module.exports = __webpack_public_path__ + "img/Galactapedia_Aegis_Dynamics.fb259273.png";